<template>
	<div class="bank">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0 mb-3">
					<div class="col-12 pt-3 pb-3 p-md-3 rounded background-white top-slider shadow d-md-flex">
						<div class="p-0 col-12 col-md-3 mt-auto">
							<button class="col-12 col-md-10 btn p-md-2 background-button-template color-white rounded box-purple" @click="toAdd('add')">
								<div class="font-size-11 font-size-sm-9"><i class="fas fa-plus-circle mr-2"></i>Tambah Bank</div>
							</button>
						</div>
						<div class="form-inline p-0 col-12 col-md-9 m-auto">
							<label class="col-12 p-0 justify-content-start color-mila font-bold mb-2 mt-3 mt-md-0 font-size-sm-10">Filter Berdasarkan</label>
							<div class="input-group col-12 col-md-6 p-0 pr-md-2">
								<select class="col-12 form-control font-size-sm-9 box-purple" v-model="pilihStatus" @change="() => inputan=''">
									<option value="member_bank_bank_name">Nama Bank</option>
									<option value="member_bank_account_no">Nomor Rekening</option>
									<option value="member_bank_account_name">Nama Pemilik</option>
								</select>
							</div>
							<div class="input-group col-12 col-md-6 p-0 pr-md-2 mt-2 mt-md-0">
								<input v-model="inputan" :placeholder="placeholderFilter" type="text" class="form-control font-size-sm-8 box-purple" @change="cari" />
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 p-md-0 mt-3 mb-3" v-show="dataBank.length == 0">
					<div class="col-12 p-0 pl-3 mt-3 rounded shadow active-address " v-for="(index) in 2" v-bind:key="index">
						<vcl :width='300' :height='45'>
							<rect x="3" y="6" rx="4" ry="4" width="30" height="11" />
							<rect x="78" y="6" rx="2" ry="2" width="7" height="6" />
							<rect x="90" y="6" rx="2" ry="2" width="40" height="4" />
							<rect x="225" y="11" rx="2" ry="2" width="30" height="9" />
							<rect x="260" y="11" rx="2" ry="2" width="30" height="9" />
							<rect x="225" y="23" rx="2" ry="2" width="65" height="9" />
							<rect x="90" y="14" rx="2" ry="2" width="50" height="4" />
							<rect x="90" y="14" rx="2" ry="2" width="30" height="4" />
							<rect x="3" y="25" rx="2" ry="2" width="7" height="6" />
							<rect x="15" y="25" rx="2" ry="2" width="35" height="4" />
							<rect x="78" y="25" rx="2" ry="2" width="7" height="6" />
							<rect x="90" y="25" rx="2" ry="2" width="40" height="4" />
							<rect x="15" y="33" rx="2" ry="2" width="28" height="4" />
							<rect x="90" y="33" rx="2" ry="2" width="32" height="4" />
						</vcl>
					</div>
				</div>
				<div class="col-12 p-md-0 mt-3 mb-3" v-if="dataBank == 'error'">
					<div class="col-12 rounded background-white shadow pt-3 pb-3" >
						<div class="text-center">
							<div><img class="img-fluid" src="/assets/icon/no-data-found.svg" alt=""></div>
							<div class="pt-3 color-black">Belum ada bank tersedia.</div>
						</div>
					</div>
				</div>
				<div class="col-12 p-md-0 mt-3 mb-3" v-else>
					<div class="col-12 p-0 pl-3 mt-3 rounded shadow font-size-sm-9 b-address" v-for="(value, index) in dataBank" :key="index" :class="value.member_bank_is_default =='1' ? 'active-address' :'' ">
						<div class="col-12 pt-3 pb-3">
							<div class="row">
								<div class="col-12 p-0 pl-md-2 pr-md-2 col-md-9">
									<div class="col-12 p-0 d-flex flex-wrap">
										<div class="col-7 p-0 col-md-4 d-flex">
											<div class="col-8 col-lg-6 mt-n1 mt-lg-n3 pl-0">
												<img class="img-fluid" :src=value.member_bank_bank_image>
											</div>
										</div>
										<div class="col-12 p-0 col-md-8 d-flex">
											<div class="col-1 p-0 text-md-center"><i class="fas fa-wallet mr-1 color-mila mt-2"></i></div>
											<div class="col-11 pl-1">
												<div class="col-11 p-0 font-bold font-size-13 font-size-sm-12 color-mila">Nomor Rekening</div>
												<div class="col-11 p-0 color-black">{{value.member_bank_account_no}}</div>
											</div>
										</div>
									</div>
									<div class="col-12 p-0 mt-2 mt-md-2 d-md-flex">
										<div class="col-12 p-0 col-md-4 d-flex">
											<div class="col-1 p-0"><i class="fas fa-university mr-1 color-mila mt-2"></i></div>
											<div class="col-11 pl-1 pl-md-3">
												<div class="col-12 p-0 font-bold font-size-13 font-size-sm-12 color-mila">Nama Bank</div>
												<div class="col-12 p-0 color-black">{{value.member_bank_bank_name}}</div>
											</div>
										</div>
										<div class="col-12 p-0 mt-2 mt-md-0 col-md-8 d-flex">
											<div class="col-1 p-0 text-md-center"><i class="fas fa-user mr-1 color-mila mt-2"></i></div>
											<div class="col-11 pl-1">
												<div class="col-12 p-0 font-bold font-size-13 font-size-sm-12 color-mila">Nama Pemilik</div>
												<div class="col-12 p-0 color-black" >{{value.member_bank_account_name}}</div>
											</div>

										</div>
									</div>
								</div>
								<div class="col-sm-12 pl-0 pr-0 pt-3 pt-md-0 col-md-3 ml-md-0 mt-auto mb-auto">
									<div class="col-12 col-md-10 pl-0 pr-3 pr-md-0 ml-md-3 d-flex flex-wrap">
										<div class="col-6 col-md-12 col-lg-6 pl-0 pr-1 pr-md-0 pr-lg-1">
											<button title="Edit" class="col-12 btn btn-outline-template font-size-15 mr-3 font-size-sm-10 box-purple" @click="toEdit(value, 'edit')">
												<i class="fas fa-edit mr-1"></i>Edit
											</button>
										</div>
										<div class="col-6 col-md-12 col-lg-6 pr-0 pl-1 pl-md-0 pl-lg-1 pt-md-2 pt-lg-0">
											<button :disabled="value.member_bank_is_default == 1" title="Hapus" class="col-12 btn btn-outline-danger font-size-15 font-size-sm-10" @click="toDelete(value.member_bank_id)">
												<i class="fas fa-trash-alt mr-1"></i>Hapus
											</button>
										</div>
									</div>
									<div class="col-12 col-md-10 pl-0 p-md-0 order-1 mt-2 ml-md-3" id="_buttonAlamat2">
										<button v-if="value.member_bank_is_default == 0" class="col-12 btn background-button-template font-size-sm-9 color-white box-purple" @click="toDefault(value.member_bank_id)">Jadikan Utama</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<v-modal ref="addBank" class="modal-small">
			<template v-slot:header>
				<div class="modal-header d-block">
					<div v-if="status == 'add'" class="font-size-16 color-black text-center">Tambah Bank</div>
					<div v-if="status == 'edit'" class="font-size-16 color-black text-center">Ubah Bank</div>
				</div>
			</template>
			<div slot="body">
				<form class="pt-3">
					<div class="form-inline">
						<v-select label="bank_name" class="col-12 col-md-10 offset-md-1 font-size-sm-9 box-purple pl-0 pr-0" type="text" :options="daftarBank" v-model="bank" placeholder="Pilihan Bank" @input="() => konfirmResponse.member_bank_bank_name=''" @click="getNamaBank">
							<template v-slot:no-options="{ search, searching }">
								<template v-if="searching">
									Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
								</template>
								<em style="opacity: 0.5;" v-else>Ketik untuk mencari Bank</em>
							</template>
						</v-select>
						<div class="font-size-8 pt-1 color-red offset-md-1" v-if="konfirmResponse.member_bank_bank_name">Bank {{konfirmResponse.member_bank_bank_name}}</div>
					</div>
					<div class="form-inline pt-3">
						<input @click="getNomorRek" @keypress="onlyNumber" v-model="param.member_bank_account_no" class="form-control col-12 offset-md-1 col-md-10 font-size-sm-9 box-purple" type="text" placeholder="Nomor Rekening" @focus="() => konfirmResponse.member_bank_account_no=''"  />
						<div class="font-size-8 pt-1 color-red offset-md-1" v-if="konfirmResponse.member_bank_account_no">Nomor Rekening {{konfirmResponse.member_bank_account_no}}</div>
					</div>
					<div class="form-inline pt-3">
						<input @click="getNama" v-model="param.member_bank_account_name" @focus="() => konfirmResponse.member_bank_account_name=''"  class="form-control col-12 offset-md-1 col-md-10 font-size-sm-9 box-purple f-lato" type="text" placeholder="Nama Pemilik" />
						<div class="font-size-8 pt-1 color-red offset-md-1" v-if="konfirmResponse.member_bank_account_name">Nama Pemilik {{konfirmResponse.member_bank_account_name}}</div>
					</div>
					<div class="form-inline pt-3 pb-3">
						<input @click="getCabang" v-model="param.member_bank_account_branch" @focus="() => konfirmResponse.member_bank_account_branch=''"  class="form-control col-12 offset-md-1 col-md-10 font-size-sm-9 box-purple f-lato" type="text" placeholder="Cabang" />
						<div class="font-size-8 pt-1 color-red offset-md-1" v-if="konfirmResponse.member_bank_account_branch">Cabang {{konfirmResponse.member_bank_account_branch}}</div>
					</div>
				</form>
			</div>
			<div slot="footer">
				<div class="modal-footer justify-content-center">
					<div class="form-inline">
						<button class="btn btn-outline-danger rounded mr-1 font-size-sm-9 pr-md-4 pl-md-4 text-capitalize" @click="hideAdd">
							<i class="fa fa-times mr-3"></i>Batal
						</button>
						<button class="btn background-button-template color-white rounded font-size-sm-9 pr-md-4 pl-md-4 text-capitalize box-purple" @click="save">
							<i class="fa fa-save mr-3"></i>Simpan
						</button>
					</div>
				</div>
			</div>
		</v-modal>

		<v-modal ref="deleteBank" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<div slot="body" class="col-12 mb-3 d-md-flex mt-n3 mt-md-0">
				<div class="col-5 m-auto pt-3">
					<img class="img-fluid" src="/assets/icon/surprise-woman.svg">
				</div>
				<div class="col-12 col-md-7 pt-3 color-black m-auto text-md-left text-center pl-0 pr-0 pl-md-3 pr-md-3">
					<div class="font-bold font-size-sm-12">Hapus Bank</div>
					<div class="font-size-sm-11 pt-2">Apakah Anda yakin untuk menghapus data bank?</div>
				</div>
			</div>
			<div slot="footer">
				<div class="modal-footer justify-content-center justify-content-md-end">
					<button class="col-6 col-md-3 btn btn-outline-danger rounded mr-1 font-size-sm-9 pr-md-4 pl-md-4 text-capitalize" @click="hideDelete">
						<i class="fa fa-times mr-1"></i>Batal
					</button>
					<button @click="deleteBank" class="col-6 col-md-4 btn background-button-template color-white rounded font-size-sm-9 pr-md-4 pl-md-4 text-capitalize box-purple">
						<i class="fa fa-check mr-1"></i>Saya yakin
					</button>
				</div>
			</div>
		</v-modal>

		<v-modal ref="defaultBank" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<div slot="body" class="col-12 mb-3 d-md-flex">
				<div class="col-5 m-auto pt-md-3">
					<img class="img-fluid" src="/assets/icon/smile-woman.svg">
				</div>
				<div class="col-12 col-md-7 pt-3 color-black m-auto text-md-left text-center pl-0 pr-0 pl-md-3 pr-md-3">
					<div class="font-bold font-size-sm-12">Konfirmasi Bank Utama</div>
					<div class="font-size-sm-11 pt-2">Apakah Anda yakin akan menjadikan Bank Utama?</div>
				</div>
			</div>
			<div slot="footer">
				<div class="modal-footer justify-content-center justify-content-md-end">
					<button class="col-6 col-md-3 btn btn-outline-danger rounded mr-1 font-size-sm-9 pr-md-4 pl-md-4 text-capitalize" @click="hideDefault">
						<i class="fa fa-times mr-1"></i>Batal
					</button>
					<button @click="updateStatus" class="col-6 col-md-4 btn background-button-template color-white rounded font-size-sm-9 pr-md-4 pl-md-4 text-capitalize box-purple">
						<i class="fa fa-check mr-1"></i>Saya Yakin
					</button>
				</div>
			</div>
		</v-modal>
	</div>
</template>

<script>
import VModal from '@/components/VModal';
import { mapState, mapActions } from 'vuex';

export default {
	name: 'Address',
	components: {
		VModal,
	},
	data() {
		return {
			id : '',
			bank : '',
			status : '',
			inputan : '',
			pilihStatus: 'member_bank_bank_name',
			param : {
				member_bank_bank_id : '',
				member_bank_bank_name : '',
				member_bank_account_name : '',
				member_bank_account_no : '',
				member_bank_account_branch : ''
			},
		}
	},
	computed:{
		...mapState('bankMember', ['dataBank', 'daftarBank', 'konfirmResponse', 'responSukses']),
		placeholderFilter() {
			if (this.pilihStatus == "member_bank_bank_name") {
				return "Masukan Nama Bank"
			} else if(this.pilihStatus == "member_bank_account_no") {
				return "Masukan Nomor Rekening"
			} else if(this.pilihStatus == "member_bank_account_name") {
				return "Masukan Nama Pemilik"
			} else {
				return "-"
			}
		}
	},
	methods: {
		...mapActions('bankMember', ['getBank', 'getListBank', 'add', 'update', 'updateStatusBank', 'hapus']),
		getNamaBank() {
			this.konfirmResponse.member_bank_bank_name = ''
		},
		getNama() {
			this.konfirmResponse.member_bank_account_name = ''
		},
		getNomorRek() {
			this.konfirmResponse.member_bank_account_no = ''
		},
		getCabang() {
			this.konfirmResponse.member_bank_account_branch = ''
		},
		cari(){
			let params = {
				'filter[0][field]': this.pilihStatus,
				'filter[0][type]': 'string',
				'filter[0][value]': this.inputan,
				'filter[0][comparison]': 'like',
				sort: 'member_bank_id',
				dir: 'DESC'
			}
			this.getBank(params)
		},
		save(){
			this.param.member_bank_bank_id = this.bank.bank_id
			this.param.member_bank_bank_name = this.bank.bank_name
			if(this.status == 'add') {
				this.add(this.param).then( () => {
					this.getBank()
					if(this.responSukses == 200 && !this.konfirmResponse.member_bank_bank_id && !this.konfirmResponse.member_bank_bank_name && !this.konfirmResponse.member_bank_account_name && !this.konfirmResponse.member_bank_account_no && !this.konfirmResponse.member_bank_account_branch) {
						this.$refs.addBank.modalHide()
						this.clearData()
					} else {
						this.$refs.addBank.modalShow();
					}
				})
			} else {
				this.update(this.param).then( () => {
					this.getBank()
					if(this.responSukses == 200 && !this.konfirmResponse.member_bank_bank_id && !this.konfirmResponse.member_bank_bank_name && !this.konfirmResponse.member_bank_account_name && !this.konfirmResponse.member_bank_account_no && !this.konfirmResponse.member_bank_account_branch) {
						this.$refs.addBank.modalHide()
						this.clearData()
					} else {
						this.$refs.addBank.modalShow();
					}
				})
			}
		},
		clearData() {
			this.bank = ''
			this.param.member_bank_bank_id = ''
			this.param.member_bank_bank_name = ''
			this.param.member_bank_account_name = ''
			this.param.member_bank_account_no = ''
			this.param.member_bank_account_branch = ''
			this.konfirmResponse.member_bank_bank_id = ''
			this.konfirmResponse.member_bank_bank_name = ''
			this.konfirmResponse.member_bank_account_name = ''
			this.konfirmResponse.member_bank_account_no = ''
			this.konfirmResponse.member_bank_account_branch = ''
		},
		toEdit(val, code) {
			this.bank = {"bank_id": val.member_bank_bank_id, "bank_name": val.member_bank_bank_name}
			this.status = code
			this.param.member_bank_id = val.member_bank_id
			this.param.member_bank_account_name = val.member_bank_account_name
			this.param.member_bank_account_no = val.member_bank_account_no
			this.param.member_bank_account_branch = val.member_bank_account_branch
			this.$refs.addBank.modalShow();		
		},
		toAdd(code) {
			this.status = code
			this.$refs.addBank.modalShow();
		},
		hideAdd() {
			this.$refs.addBank.modalHide();
			this.status = ''
			this.clearData()
			this.konfirmResponse.member_bank_bank_id = ''
			this.konfirmResponse.member_bank_bank_name = ''
			this.konfirmResponse.member_bank_account_name = ''
			this.konfirmResponse.member_bank_account_no = ''
			this.konfirmResponse.member_bank_account_branch = ''
		},
		toDefault(val) {
			this.id = val
			this.$refs.defaultBank.modalShow();
		},
		updateStatus() {
			this.updateStatusBank(this.id).then(() => {
				this.getBank()
				this.id = ''
				this.$refs.defaultBank.modalHide();
			})
		},
		hideDefault() {
			this.id = ''
			this.$refs.defaultBank.modalHide();
		},
		toDelete(val) {
			this.id = val
			this.$refs.deleteBank.modalShow();
		},
		deleteBank() {
			this.hapus(this.id).then(() => {
				this.getBank()
				this.id = ''
				this.$refs.deleteBank.modalHide();
			})
		},
		hideDelete() {
			this.id = ''
			this.$refs.deleteBank.modalHide();
		},

	},
	created() {
		this.getBank()
		this.getListBank()
	}
}
</script>

<style scoped>
.b-address {
	border: 1px solid #f7f7f7;
	border-left-width: 10px;
}
.active-address {
	border: 1px solid #7C1CC6 !important;
	border-left-width: 10px !important;
}
</style>